const RECEIVE_ADGROUPS = 'src/adEntities/RECEIVE_ADGROUPS' as const;
const CLEAR_ADGROUPS = 'src/adEntities/CLEAR_ADGROUPS' as const;

export default {
  CLEAR_ADGROUPS,
  RECEIVE_ADGROUPS
};
